var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatureGroupbg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 585,
    height: 613.236,
    viewBox: "0 0 585 613.236",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Polygon_1",
    x: 0,
    y: 543.202,
    width: 54,
    height: 54,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Polygon_2",
    x: 480,
    y: 161.202,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Polygon_3",
    x: 549,
    y: 262.202,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25442",
    "data-name": "Group 25442",
    transform: "translate(-131 -1916.798)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25334",
    "data-name": "Group 25334",
    transform: "translate(172.147 1916.707)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1294",
    "data-name": "Rectangle 1294",
    width: 13.657,
    height: 110.962,
    rx: 2,
    transform: "translate(49.286 0.091)",
    fill: "#cdff57"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1295",
    "data-name": "Rectangle 1295",
    width: 14.035,
    height: 110.875,
    rx: 2,
    transform: "matrix(0.017, -1, 1, 0.017, 0, 61.421)",
    fill: "#cdff57"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1296",
    "data-name": "Rectangle 1296",
    width: 14.035,
    height: 110.875,
    rx: 2,
    transform: "translate(22.875 100.702) rotate(-137)",
    fill: "#cdff57"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1297",
    "data-name": "Rectangle 1297",
    width: 14.035,
    height: 110.875,
    rx: 2,
    transform: "translate(12.611 19.614) rotate(-43)",
    fill: "#cdff57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "phone_mockup",
    "data-name": "phone mockup",
    transform: "translate(160.309 1995.206)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle",
    transform: "translate(17.113 91.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mask",
    d: "M443.519,221.76c0,122.475-99.285,221.76-221.76,221.76S0,344.234,0,221.76,99.285,0,221.76,0,443.519,99.285,443.519,221.76Z",
    fill: "#141416"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mask-2",
    "data-name": "mask",
    d: "M412.151,206.075c0,113.813-92.263,206.075-206.075,206.075S0,319.888,0,206.075,92.263,0,206.075,0,412.151,92.263,412.151,206.075Z",
    transform: "translate(15.684 15.684)",
    fill: "none",
    stroke: "#464646",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "mask-3",
    "data-name": "mask",
    d: "M374.626,187.313c0,103.45-83.863,187.313-187.313,187.313S0,290.764,0,187.313,83.863,0,187.313,0,374.626,83.863,374.626,187.313Z",
    transform: "translate(34.446 34.446)",
    fill: "none",
    stroke: "#464646",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "mask-4",
    "data-name": "mask",
    d: "M338.186,169.093A169.093,169.093,0,1,1,169.093,0,169.093,169.093,0,0,1,338.186,169.093Z",
    transform: "translate(52.667 52.667)",
    fill: "none",
    stroke: "#464646",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -29.31, -78.41)",
    filter: "url(#Polygon_1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-2",
    "data-name": "Polygon 1",
    d: "M17.057,2.685a1,1,0,0,1,1.887,0l3.577,10.182a1,1,0,0,0,.612.612l10.182,3.577a1,1,0,0,1,0,1.887L23.133,22.521a1,1,0,0,0-.612.612L18.943,33.315a1,1,0,0,1-1.887,0L13.479,23.133a1,1,0,0,0-.612-.612L2.685,18.943a1,1,0,0,1,0-1.887l10.182-3.577a1,1,0,0,0,.612-.612Z",
    transform: "translate(9 552.2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -29.31, -78.41)",
    filter: "url(#Polygon_2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2-2",
    "data-name": "Polygon 2",
    d: "M13.057,2.685a1,1,0,0,1,1.887,0l2.537,7.222a1,1,0,0,0,.612.612l7.222,2.537a1,1,0,0,1,0,1.887l-7.222,2.537a1,1,0,0,0-.612.612l-2.537,7.222a1,1,0,0,1-1.887,0l-2.537-7.222a1,1,0,0,0-.612-.612L2.685,14.943a1,1,0,0,1,0-1.887l7.222-2.537a1,1,0,0,0,.612-.612Z",
    transform: "translate(489 170.2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -29.31, -78.41)",
    filter: "url(#Polygon_3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_3-2",
    "data-name": "Polygon 3",
    d: "M8.057,2.685a1,1,0,0,1,1.887,0l1.237,3.522a1,1,0,0,0,.612.612l3.522,1.237a1,1,0,0,1,0,1.887l-3.522,1.237a1,1,0,0,0-.612.612L9.943,15.315a1,1,0,0,1-1.887,0L6.819,11.793a1,1,0,0,0-.612-.612L2.685,9.943a1,1,0,0,1,0-1.887L6.207,6.819a1,1,0,0,0,.612-.612Z",
    transform: "translate(558 271.2)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureGroupbg);
export default __webpack_public_path__ + "static/media/featureGroupbg.3a0a5297484e111061ab360ba6c1066b.svg";
export { ForwardRef as ReactComponent };